import {
  BreakEdit,
  BreakView,
  TextView,
  NumbersView,
  NumbersEdit,
  NumbersSchema,
  AccordionEdit,
  AccordionView,
  AccordionSchema,
  DownloadsTemplate,
  ListingLinkMore,
  TabsView,
  TabsEdit,
  TabsSchema,
} from '@redturtle/volto-rt-blocks/components/Blocks';
import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';
import { PanelsWidget } from '@eeacms/volto-accordion-block/components';

/* Icons */
import divideHorizontalSVG from '@plone/volto/icons/divide-horizontal.svg';
import accordionSVG from '@plone/volto/icons/list-arrows.svg';
import numbersSVG from '@redturtle/volto-rt-blocks/icons/numeri.svg';
import tabsSVG from '@redturtle/volto-rt-blocks/icons/tabs.svg';

const applyConfig = (config) => {
  config.blocks.blocksConfig = {
    ...config.blocks.blocksConfig,

    /* Blocchi elenco */
    listing: {
      ...config.blocks.blocksConfig.listing,
      variations: [
        ...config.blocks.blocksConfig.listing.variations,
        {
          id: 'downloads',
          isDefault: true,
          title: 'Downloads',
          template: DownloadsTemplate,
        },
      ],
      link_more: {
        component: ListingLinkMore,
      },
    },

    /* Text */
    slate: {
      ...config.blocks.blocksConfig.slate,
      sidebarTab: 1,
      view: TextView,
      schemaEnhancer: ({ schema, formData, intl }) => {
        addStyling({ schema, intl });

        schema.properties.styles.schema.fieldsets[0].fields = [
          ...schema.properties.styles.schema.fieldsets[0].fields,
          'bg',
        ];
        schema.properties.styles.schema.properties.bg = {
          widget: 'color_picker',
          title: 'Colore di sfondo',
          colors:  [
            {name: 'transparent', label: 'Nessuno'},
            {name: 'primary', label: 'Primario'},
            {name: 'light-gray', label: 'Grigio chiaro'},
          ],
          default: 'transparent',
        };
        return schema;
      },
    },

    /* Break */
    break: {
      id: 'break',
      title: 'Interruzione di pagina',
      icon: divideHorizontalSVG,
      group: 'text',
      view: BreakView,
      edit: BreakEdit,
      sidebarTab: 0,
    },

    /* Numbers */
    numbers: {
      id: 'numbers',
      title: 'Numeri',
      icon: numbersSVG,
      group: 'text',
      view: NumbersView,
      edit: NumbersEdit,
      sidebarTab: 1,
      schema: NumbersSchema,
    },

    /* Accordion */
    accordion: {
      id: 'accordion',
      title: 'Accordion',
      icon: accordionSVG,
      group: 'text',
      view: AccordionView,
      edit: AccordionEdit,
      schema: AccordionSchema,
      sidebarTab: 1,
    },

     /* Tabs */
    tabs: {
      id: 'tabs',
      title: 'Tabs',
      icon: tabsSVG,
      group: 'text',
      view: TabsView,
      edit: TabsEdit,
      schema: TabsSchema,
      restricted: false,
      mostUsed: false,
      blockHasOwnFocusManagement: true,
      sidebarTab: 1,
      security: {
        addPermission: [],
        view: [],
      },
    },
  };

  config.widgets.type.panels = PanelsWidget;

  return config;
};

export default applyConfig;
